import { APIClient } from "./api_helper";
import * as url from "./url_helper";

const api = new APIClient();

// Gets the logged in user data from local session
export const getLoggedInUser = () => {
  const user = localStorage.getItem("user");
  if (user) return JSON.parse(user);
  return null;
};

export const isUserAuthenticated = () => {
  return getLoggedInUser() !== null;
};

// Register
export const postFakeRegister = (data) => api.create(url.POST_FAKE_REGISTER, data);

// Login
export const postFakeLogin = (data) => api.create(url.POST_FAKE_LOGIN, data);
export const postJwtLogin = (data) => api.create(url.POST_FAKE_JWT_LOGIN, data);
export const postBackendLogin = (data) => api.create(url.BACKEND_LOGIN, data);
export const postSocialLogin = (data) => api.create(url.SOCIAL_LOGIN, data);

// Forget password
export const postFakeForgetPwd = (data) => api.create(url.POST_FAKE_PASSWORD_FORGET, data);
export const postJwtForgetPwd = (data) => api.create(url.POST_FAKE_JWT_PASSWORD_FORGET, data);

// Profile
export const postJwtProfile = (data) => api.create(url.POST_EDIT_JWT_PROFILE, data);
export const postFakeProfile = (data) => api.update(url.POST_EDIT_PROFILE + "/" + data.idx, data);

// Register (JWT)
export const postJwtRegister = (urlPath, data) => {
  return api.create(urlPath, data).catch((err) => {
    let message;
    if (err.response && err.response.status) {
      switch (err.response.status) {
        case 404:
          message = "Sorry! the page you are looking for could not be found";
          break;
        case 500:
          message = "Sorry! something went wrong, please contact our support team";
          break;
        case 401:
          message = "Invalid credentials";
          break;
        default:
          message = err[1];
          break;
      }
    }
    throw message;
  });
};
